<ion-card 
  button 
  [style.box-shadow]="styles?.boxShadow" 
  [style.border-radius]="styles?.radius"
  [style.border]="styles?.border" 
  [style.margin]="styles?.margin" 
  class="full-width ion-no-margin">

  <!-- Image Container -->
  <div [style.padding]="styles?.padding" class="image-container">
    <div 
      class="bg-img" 
      [offset]="300" 
      defaultImage="./assets/imgs/placeholder.png"
      [lazyLoad]="item.featuredImageThumb?._url">
    </div>
    
    <span *ngIf="item.salePrice">
      {{ item.discount | percent }} {{ 'OFF' | translate }}
    </span>
  </div>

  <!-- Content -->
  <ion-card-content>
    
    <!-- Product Name -->
    <ion-text>
      <p class="link">{{ item.name }}</p>
    </ion-text>

    <!-- Rating -->
    <bar-rating [rate]="item.ratingAvg" [readOnly]="true" [max]="5">
      <ng-template ratingActive>
        <ion-icon name="star" color="warning"></ion-icon>
      </ng-template>
      <ng-template ratingInactive>
        <ion-icon name="star-outline" color="medium"></ion-icon>
      </ng-template>
    </bar-rating>

    <!-- Price -->
    <div class="price-wrapper">
      <ng-container *ngIf="item.salePrice; else regularPrice">
        <span class="current-price">{{ item.salePrice | currencyGlobal }}</span>
        <span class="original-price">{{ item.price | currencyGlobal }}</span>
      </ng-container>
      
      <ng-template #regularPrice>
        <span class="current-price">{{ item.price | currencyGlobal }}</span>
      </ng-template>
    </div>

  </ion-card-content>
</ion-card>